import React, { useEffect, useState, useMemo } from "react";

import Paper from "@/app/pages/contactProfile/Paper";
import { isNotUndefined, setCompanyInfoCookie } from "@/shared/FunctionCore";
import "@/app/pages/contactProfile/styles/ContactProfileOverviewStyles.scss"
import { Helmet } from "react-helmet";

const Overview = ({ contactProfilePageData }) => {
  const {
    contact,
    contactCompanyProfileHref,
    industryUrls,
  } = contactProfilePageData;

  const {
    email,
    emailDomainName,
    familyName,
    givenName,
    organization,
    telephoneNumber,
    title
  } = contact;

  useEffect(() => {
    const companyInformationForCookie = organization?.companyInformationForCookie;

    if (isNotUndefined(companyInformationForCookie)) {
      setCompanyInfoCookie(companyInformationForCookie);
    }
  }, []);

  const companyProfileUrl = useMemo(() =>
    "/business-directory/company-profiles" +
    contactProfilePageData.contactCompanyProfileHref +
    ".html"
  , [contactProfilePageData.contactCompanyProfileHref])

  const organizationTelephoneNumber = organization?.telephoneNumber;

  const addressCountry = organization?.addressCountry;
  const addressLocality = organization?.addressLocality;
  const addressRegion = organization?.addressRegion;
  const postalCode = organization?.postalCode;
  const primaryName = organization?.primaryName;
  const streetAddress = organization?.streetAddress;

  let locationString = "";

  if (isNotUndefined(streetAddress)) {
    locationString = `${locationString + streetAddress}, `;
  }

  if (isNotUndefined(addressLocality)) {
    locationString = `${locationString + addressLocality}, `;
  }

  if (isNotUndefined(addressRegion)) {
    locationString = `${locationString + addressRegion}, `;
  }

  if (isNotUndefined(postalCode)) {
    locationString = `${locationString + postalCode}, `;
  }

  if (isNotUndefined(addressCountry)) {
    locationString = locationString + addressCountry;
  }

  const [showModal, setShowModal] = useState(false);

  const onClickModalButton = (type: "close" | "open") => setShowModal(type === "open");

  const industryUrlsFirstElement = industryUrls[0]!;

  const industryUrlsFirstElementUrl = industryUrlsFirstElement?.url;

  const rightSideBlock = () => (
    <div className="col-md-6 pull-right text-right hidden-xs hidden-sm">
      <span className="col-md-12 unlock position-absolute">
        <span className="unlock-icon" />
        <a
          className="suppress-ms-ext-icon anchor"
          onClick={() => onClickModalButton("open")}>
          Unlock full details for
          {" "}

          {givenName}

          {" "}

          {familyName}

          <span className="right-arrow" />
        </a>
      </span>
    </div>
  )

  const customPageTitle =()=>{
    let fullName = givenName + " " + familyName;
    let emailAddress = email && email?.length > 0 ? "Email Address" : "";
    let phoneNumber = telephoneNumber && telephoneNumber?.length > 0 ? "Phone Number" : "";
    let pageTitle= [ fullName, emailAddress, phoneNumber, primaryName, title ].filter(Boolean).join(" | ");
    return pageTitle;
  }

  return (
    <> 
    <Helmet>
      <title>{customPageTitle()} </title>
    </Helmet>
    <Paper
      title="Overview"
      blockName="contact-profile-overview"
      blockId="overview-block"
      onClickModalButton={onClickModalButton}
      showModal={showModal}
      rightHandSubtitle={rightSideBlock()}
    >

      <div className="row">
        <div className="col-md-6 col-12">
          {
            givenName?.length > 0
              ?
              <div className="row overview-item">
                <div className="col-md-1 col-2 personImage" />

                <div className="col-md-10 col-10 pl-20">

                  <span>
                    Name:
                  </span>

                  {" "}

                  {givenName}

                  {" "}

                  {familyName}
                </div>
              </div>
              : <></>
          }

          {title?.length > 0 ? (
            <div className="row overview-item">
              <div className="col-md-1 col-2 workIcon" />

              <div className="col-md-10 col-10 pl-20">
                <label>
                  Title:
                  {" "}
                </label> {title}
              </div>
            </div>
          ) : (
            <></>
          )}

          {email && email?.length > 0 ? (
            <div className="row  overview-item">
              <div className="col-md-1 col-2 emailIcon" />

              <div className="col-md-10 col-10 pl-20">
                <label>
                  Email:
                  {" "}
                </label>
                <span className="spacing-pl-1">{email}</span>

                {" "}

                <a
                  className="btn-access-red suppress-ms-ext-icon spacing-mr-2"
                  onClick={() => onClickModalButton("open")}>
                  Get Email Address
                </a>
              </div>
            </div>
          ) : (
            <></>
          )}

          {telephoneNumber && telephoneNumber?.length > 0 ? (
            <div className="row overview-item">
              <div className="col-md-1 col-2 phoneIcon" />

              <div className="col-md-10 col-10 pl-20">
                <label>
                  Direct Dial:
                  {" "}
                </label> {telephoneNumber}

                {" "}

                <a
                  className="float-right btn-access-red suppress-ms-ext-icon spacing-mr-2"
                  onClick={() => onClickModalButton("open")}>
                  Get Direct Dial
                </a>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>

        <div className="col-md-6 col-12 spacing-pl-2">
          {isNotUndefined(primaryName) && primaryName?.length > 0 ? (
            <div className="row overview-item">
              <div className="col-md-1 col-2 businessIcon" />

              <div className="col-md-10 col-10 pl-20">
                <label>
                  Company:
                  {" "}
                </label>

                {" "}

                <a
                  className="ContactProfileOverviewFragmentComponentPrimaryNameLink contact-company link-with-underline"
                  href={companyProfileUrl}>
                  {primaryName}
                </a>
              </div>
            </div>
          ) : (
            <></>
          )}

          {locationString && locationString?.length > 0 ? (
            <div className="row overview-item">
              <div className="col-md-1 col-2 locationIcon" />

              <div className="col-md-10 col-10 pl-20">
                <label>
                  Location:
                  {" "}
                </label>

                {" "}

                {locationString}
              </div>
            </div>
          ) : (
            <></>
          )}

          {emailDomainName && emailDomainName?.length > 0 ? (
            <div className="row overview-item">
              <div className="col-md-1 col-2 desktopIcon" />

              <div className="col-md-10 col-10 pl-20">
                <label>
                  Website:
                  {" "}
                </label>

                {" "}

                <a
                  className="link-with-underline ext-icon"
                  href={emailDomainName.includes("http") ? emailDomainName : `https://${emailDomainName}`}
                  rel="noreferrer"
                  target="_blank">
                  {emailDomainName}
                </a>
              </div>
            </div>
          ) : (
            <></>
          )}

          {isNotUndefined(organizationTelephoneNumber) && organizationTelephoneNumber?.length > 0 ? (
            <div className="row overview-item">
              <div className="col-md-1 col-2 phoneIcon" />

              <div className="col-md-10 col-10 pl-20">
                <label>
                  Company Phone:
                  {" "}
                </label> {organizationTelephoneNumber}
              </div>
            </div>
          ) : (
            <></>
          )}

          {isNotUndefined(industryUrlsFirstElement) && isNotUndefined(industryUrlsFirstElementUrl) && industryUrlsFirstElementUrl.length > 0 ? (
            <div className="row overview-item">
              <div className="col-md-1 col-2 industryIcon" />

              <div className="col-md-10 col-10 pl-20">
                <label>
                  Industry:
                  {" "}
                </label>

                {" "}

                <a className="anchor" href={industryUrlsFirstElementUrl}>
                  {industryUrlsFirstElement.description}

                  <span className="right-arrow" />
                </a>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>

      <div className="row">
        <div className="col-12 hidden-md hidden-lg text-center">
          <div className="unlock">
            <span className="unlock-icon" />

            <a
              className="ContactProfileOverviewFragmentComponentUnlockFullDetailsForGivenNameFamilyNameLinkBottom
                                unlock-contact-full-details suppress-ms-ext-icon"
              onClick={() => onClickModalButton("open")}>
              Unlock full details for
              {" "}

              {givenName}

              {" "}

              {familyName}

              <span className="right-arrow" />
            </a>
          </div>
        </div>
      </div>
    </Paper>
    </>
  )
}

export default Overview